<template>
	<div id="plate-groups">
		<menu-component></menu-component>
		<div id="screen-container" class="screen-container">
			<default-header></default-header>
			<div id="panel-container">
				<collapsible-panel :panel="view.mainPanel" 
				:class="{'collapsible-panel-fullscren': view.mainPanel.fullscreen}">
					<div class="double-grid-container">
						<grid-component
							id="groupGrid" class="half-grid"
							:grid="view.mainPanel.accessProfile.gridConfiguration"
                            @update:hasCheckedRows="refreshAccessProfilePermissionsGrid"
						></grid-component>
						<div class="half-grid">
							<grid-component
								id="accessProfilePremissionsGrid" 
								:grid="view.mainPanel.accessProfilePermissions.gridConfiguration"
							>
							</grid-component>
						</div>
					</div>
					<div class="double-grid-btn-container">
						<span class="right-grid-button-container" v-if="view.mainPanel.accessProfile.hasCheckedRows">
							<button class="button grid-button"
							@click="grantAllPermissions">
								<i class="fas fa-unlock-alt"></i> {{$t('allow_all')}} </button>
							<button class="button grid-button"
							@click="revokeAllPermissions">
								<i class="fas fa-lock"></i> {{$t('revoke_all')}} </button>
						</span>
					</div>
 				</collapsible-panel>
			</div>
		</div>
		<modal name="userGrid" :height="500">
			<div class="permission-control-user-grid">
				<span class="permission-control-modal-title">
					<span class="selected-profile-text-hint"> {{$t('profile_users')}} </span>
					<span class="selected-profile-description"> {{view.mainPanel.selectedProfileDescription}} </span>
				</span>
				<grid-component
					class="user-grid"
					:grid="view.mainPanel.accessProfile.usersGridConfiguration"
				></grid-component>
			</div>
		</modal>
	</div>
</template>

<script>
import PermissionControllController from '../controllers/PermissionControllController'

import MenuComponent from '@/components/src/MenuComponent';
import DefaultHeader from '@/components/src/DefaultHeaderComponent';
import CollapsiblePanel from '@/components/src/CollapsiblePanelComponent';
import Grid from "@/components/src/GridComponent";
import eventModule from '@/application/libs/eventModule';
import Util from '@/application/libs/util';
import modal from "vue-js-modal"
import { t } from 'i18next'

export default {
	name: "Plates",
	components:{
		'menu-component':MenuComponent,
		'default-header':DefaultHeader,
		'collapsible-panel':CollapsiblePanel,
		'grid-component': Grid
	},
	data() {
		return {
			view: {
				title:t('permissions_control'),
				mainPanel:{
					collapsed:false,
					fullscreen:true,
					title:t('permissions_control'),
					name:"PermissionControll",
					info:` `,
					accessProfile:{
						gridConfiguration: PermissionControllController.AccessProfileGridConfig,
						usersGridConfiguration: PermissionControllController.UsersGridConfiguration,
                        hasCheckedRows: false
					},
					accessProfilePermissions:{
						gridConfiguration: PermissionControllController.AccessProfilePermissionGridConfig,
					},
					selectedProfileDescription: "" 
				}
			}
		};
	},
	created(){
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;
		PermissionControllController.context.reactiveVars.$modal = this.$modal;
	},
	beforeDestroy(){
		delete PermissionControllController.context.reactiveVars.$modal;
		delete PermissionControllController.context.selectedProfileID;
	},
	methods: {
		grantAllPermissions: function(){
			PermissionControllController.grantAllPermissions();
		},
		revokeAllPermissions: function() {
			PermissionControllController.revokeAllPermissions();
		},
        refreshAccessProfilePermissionsGrid: function(ev){
            if(ev){
				this.view.mainPanel.accessProfile.hasCheckedRows = ev;
				const selectedAccessProfile = PermissionControllController.AccessProfileGridConfig.gridControl.getSelectedRows()[0];
				if(selectedAccessProfile){
					PermissionControllController.context.selectedProfileID = selectedAccessProfile.NRPERFILACESSO;
					this.view.mainPanel.selectedProfileDescription = `${selectedAccessProfile.NRPERFILACESSO} - ${selectedAccessProfile.NMPERFILACESSO}`;
					PermissionControllController.AccessProfilePermissionGridConfig.reloadData();
				}
            }
        }
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

	.v--modal-overlay{
		z-index: 10;
	}

	#collapsible-panel.collapsible-panel-fullscren{
		position: fixed;
		top: 48px;
    	left: 100px;
		z-index: 2;
		background-color: white;
		height: calc(100vh - 69px);
    	width: calc(100vw - 125px);
		padding: 20px 15px;
		border-radius: 0;
		padding-top: 0px;
		margin:0;

		#panel-header{
			.up-arrow, .down-arrow{
				display: none;
			}
		}

		#panel-content{
			.ag-grid-instance{
				height: calc(100vh - 126px);
			}
		}
	}

	.select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
    }
    
    .permission-controll-check-editor{
        text-align: center;
		cursor: pointer;
		font-size: 21px;
	}
	
	.permission-control-user-grid{
		height: calc(100% - 20px);
		padding: 10px;
		display: flex;
		flex-direction: column;

		.permission-control-modal-title{
			margin-top: 10px;
			font-size: 1.2rem;

			.selected-profile-text-hint{
				opacity: .55;
			}
		}
	}
</style>
<style scoped lang="less">
#plate-groups{
	height: 100vh;
	width: 100vw;
	display: flex;

	#header-component{
			position: fixed;
			z-index: 7;
			width: calc(100% - 100px);
		}
		#panel-container{
			margin-top: 55px;
		}

	.grid-button{
		margin-top: 3px;
		font-size: .9rem;
		padding: 6px 13px;
		margin-left: 5px;
	}

	.screen-container{
		height: 100vh;
		overflow-y: scroll;
		flex: 1;
	}

	.double-grid-container{
		display: flex;
		justify-content: space-around;

		div.half-grid{
			width: 49%;
			position: relative;
			// height: 430px;

			.grid-overlay{
				position: absolute;
    			top: 0;
				height: 100%;
				width: 100%;
				background: rgba(0,0,0,.3);
				display:flex;
				align-items: center;

				span{
					width:100%;
					text-align:center;
					text-shadow: -1px 1px white;
					font-size: 1.3rem;
					color: rgba(0,0,0,.85);
				}
			}
		}

	}
	.double-grid-btn-container{
		padding-bottom: 3px;
		display: flex;

		span{
			width: calc(50% - 10px);
			margin: 0 5px;
		}

		.button.disabled{
			background-color: gray;
			pointer-events: none;
		}

		.right-grid-button-container{
			display: inline-flex;
			justify-content: flex-end;
			flex: 1;
		}
	}

	.gray-button{
		.grid-button;
		box-shadow: none;
		background-color: #dedede;
		color: #383838;
		&:hover{
			background-color: gray;
			color:white;
		}
	}

	.button-container-align-left, .button-container-align-right{
		display: inline-block;
		flex: 1;
	}

	.button-container-align-right{
		text-align: right;
		&.full-width{
			width: 100%;
		}
	}

	.low-height-grid{
		height: 200px;
	}

	.user-grid{
		flex: 1;
		height: 100%;
		margin-top: 10px;
	}
	
	.button-container{
		display: flex;
    	justify-content: space-between;
	}
}

</style>
